import { useState, useEffect, useContext } from 'react'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { listarProcessos } from '../../services/processos'
import Organizacao from '../../middleware/Organizacao'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import SubMenuOpcoes from '../SubMenuOpcoes'
import Permissoes from '../../middleware/Permissoes'
import '../../styles/menuopcoes.css'

function MenuProcessos (props: menuOpcoes) {

    const { atualizarInformacoes } = useContext(ModalEstadoContext)

    const [subMenu, setSubMenu] = useState(false)
    const [meusProcessos, setMeusProcessos] = useState(0)
    const [processosEstritorio, setProcessosEscritorio] = useState(0)
    const data = new Date()

    const ano = data.getFullYear()
    const qtnDias = new Date(data.getFullYear(), data.getMonth() + 1, 0).getDate()
    const dataAnterior = new Date(new Date().setDate(new Date().getDate() - 360))

    const [dataInicial] = useState(`${dataAnterior.getFullYear()}-${(dataAnterior.getMonth() + 1).toString().padStart(2, '0')}-01`);
    const [dataFinal] = useState(`${ano}-${(data.getMonth() + 1).toString().padStart(2, '0')}-${qtnDias}`);

    function exibirSubmenu () {
        setSubMenu (subMenu => !subMenu)
    }

    useEffect(() => {
        
        const buscarMeusProcessos = async () => {

            const params = {
                pagina: 1,
                titulo: '',
                descricao: '',
                cliente: '',
                responsavel: '',
                situacao: 'ativo',
                minhasSolicitacoes: false,
                processosEscritorio: 'false',
                dataInicial,
                dataFinal
            }

            try {

                const resposta = await listarProcessos(params)

                if (resposta.status === 200) return setMeusProcessos(resposta.data.length)
                
            } catch (error) {
                
            }
        }

        buscarMeusProcessos ()

    }, [atualizarInformacoes])

    useEffect(() => {
        
        const buscarProcessosEscritorio = async () => {

            const params = {
                pagina: 1,
                titulo: '',
                descricao: '',
                cliente: '',
                responsavel: '',
                situacao: 'ativo',
                minhasSolicitacoes: false,
                processosEscritorio: 'true',
                dataInicial,
                dataFinal
            }

            try {

                const resposta = await listarProcessos(params)

                if (resposta.status === 200) return setProcessosEscritorio(resposta.data.length)
                
            } catch (error) {
                
            }
        }

        buscarProcessosEscritorio ()

    }, [atualizarInformacoes])

    return (
        <div>
            <div id = 'menuOpcoes' onClick={exibirSubmenu}>
                {<img id = 'iconeMenu' src= {props.icone} alt = {props.alt}></img>}
                <p id = 'tituloMenu'>{props.titulo}</p>
                {meusProcessos !== 0 ? <h2>{meusProcessos}</h2> : null}
            </div>
            <div id = 'submenuOpcoes'>
                <Permissoes permissoes={['master', 'administrativo', 'processo_todos']}>
                    <>
                        {subMenu && <SubMenuOpcoes redirect = '/processos?escritorio=true' texto = 'Todos os Processos' notificacao={processosEstritorio === 0 ? null : processosEstritorio} />}
                    </>
                </Permissoes>
                {subMenu && <SubMenuOpcoes redirect = '/processos' texto = 'Meus Processos' notificacao={meusProcessos === 0 ? null : meusProcessos} />}
                <Permissoes permissoes={['master', 'processo_modelos']}>
                    <>
                        {subMenu && <SubMenuOpcoes redirect = '/modelos-processos' texto = 'Modelos de Processos' />}
                    </>
                </Permissoes>
                <Organizacao organizacao={[`${process.env.REACT_APP_ORGANIZACAO_HG}`]}>
                    <Permissoes permissoes={['master', 'processo_template']}>
                        <>
                            {subMenu && <SubMenuOpcoes redirect = '/modelos-processos/tamplets' texto = 'Tamplets' />}
                        </>
                    </Permissoes>
                </Organizacao>
            </div>
        </div>
    )
}

export default MenuProcessos